<template>
  <div class="bg_white">
    <van-nav-bar :title="title" left-text="" left-arrow @click-left="onClickLeft" fixed background="#fff"
      @click-right="onClickRight">
      <template #right>
        <van-icon name="wap-home-o" size="20" />
      </template>
    </van-nav-bar>
    <div class="bottombox"></div>
    <!-- <van-sticky :offset-top="50"> -->
      <div id="common-video" class="h-100">
        <div :class="{ isShow: control }" class="h-100">
          <video ref="myVideo" :poster="poster" :src="src" :controls="controls" crossOrigin="anonymous"   x5-playsinline="" playsinline="" webkit-playsinline="true"
            oncontextmenu="return false" @timeupdate="timeupdate" @ratechange="onRateChange" controlslist="nodownload" class="video-box"></video>
        </div>

      </div>
    <!-- </van-sticky> -->
    <van-tabs v-model="active">
      <van-tab title="课程章节">
        <van-collapse v-model="activeNames">
          <van-collapse-item v-for="item in sectionlist" :title="'第' + item + '章'" :name="item" :key="item">
            <van-cell v-for="(course,index) in courseList" center v-show="course.sysCourse.chapter + '' == item" :title-class="{'active':courseNow==index}"
              :title="course.sysCourse.title" :key="course.sysCourse.id" is-link @click="study(index)">
              <template #label>
                <div class="flex fl_bw"><span v-if="course.isNeed==1" style="color: red;">必修</span><span>时长: {{ course.sysCourse.duration }} </span><span>已学:
                    {{ getTime(course.studyTime) }}</span> <span v-if="course.studyStatus ==1" style="color: #1989fa;">已完成</span> </div>
              </template>
            </van-cell>
          </van-collapse-item>
        </van-collapse>
      </van-tab>
      <van-tab title="课程记录">
        <ul class="courseDetail">
          <li v-for="course in courseList" :key="course.sysCourse.id">
              <span>{{course.sysCourse.title}}</span>
              <span  style="color: #1989fa;">{{course.studyStatus ==1?'已完成':'未完成'}}</span>
            </li>
        </ul>
        
      </van-tab>
    </van-tabs>

    <van-overlay :show="showCheckFace" @click="showCheckFace = false">
      <div class="wrapper" @click.stop>
        <div class="compareFace" >
          <van-cell-group>
        <template #title>
          <span class="title">点击实时人脸识别：</span>
        </template>
        <div class="pd16 flex upImg">
          <van-uploader v-model="file1" multipart :max-count="1" upload-text="点我拍照"  :before-read="beforeRead" :after-read="afterRead" capture="camera">
            <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span><span>点我拍照</span>
          </van-uploader>
        </div>
      </van-cell-group>

      <div class="pd16 m40">
        <van-button class="btn_bg" round block type="default" size="normal" @click="submitCompareFace">提交认证</van-button>
      </div>
        </div>
      </div>
    </van-overlay>

    <div class="bottombox"></div>
    <van-button type="info" block class="fixedBottom" @click="operateVideo" >{{videoState?"学习中":"开始学习"}}</van-button>
  </div>

</template>

<script>
import * as imageConversion from 'image-conversion'
import { getCourseDetail, getCourseProject, saveStudyTime,studyCompareFace } from '../../api/course';
import { upload } from "../../api/upload";
export default {
  data() {
    return {
      ifCheckFace:false,
      comparFaceParam: {
        upPhoto: '',
        id:null
      },
      file1: [],//用于上传实拍照片
      showCheckFace:false,
      compareFaceTimer:{},//人脸识别定时器
      ifready:false,
      courseNow: null,
      title: "",
      activeNames: ['1'],
      active: 0,
      src: "", // 视频资源
      hostdomain:"http://fzyjs.fzsyjxh.com/",
      videoState: false, // 视频播放状态

      param: {
        courseId: '',
        duration: '',
        projectId: null
      },
      // 学时
      studyTime: {
        currentTime: 0, // 当前已学时长
        duration: 0 // 总时长
      },
      timer: {}, // 定时器
      pauseTimer: {}, // 暂停定时器
      poster: '', // 展示图
      controls: true,//是否显示控件
      control: true, // 控件控制
      videoData: '', // 视频基础数据
      startTime:0,
      courseList: [],
      sectionlist: []

    }

  },
  created() {
    this.param.projectId = this.common.getQueryString("id")
  },
  mounted() {
    //this.subStudytime();
    this.getDetail()
    // 监听视频播放
    this.$refs.myVideo.addEventListener("play", () => {
      console.log("video is playing");
      this.openTimer();  
    });
    // 监听视频暂停
    this.$refs.myVideo.addEventListener("pause", () => {
      console.log("video is stop");
      this.closeTimer();
    });
    // 监听视频播放完成
    this.$refs.myVideo.addEventListener("ended", () => {
      console.log("video is ended");
      this.subStudytime()//提交播放时间
      //清除定时器
      this.closeTimer();
      this.closePauseTimer();
      if(this.ifCheckFace){
        this.closeCheckFaceTime();
      }
      
    });

    this.$refs.myVideo.addEventListener("canplay", () => {
      if(this.startTime !=0){
        this.ifready=true
        this.$refs.myVideo.currentTime=this.startTime
        this.startTime=0
      }   
    });
  },
  methods: {
    //开启人脸识别定时器（1分钟）
    startCheckFaceTime(){
      let that = this
      console.log("开启人脸识别定时器")
      this.compareFaceTimer = setTimeout(() => {
        that.subStudytime()
        that.closePauseTimer();//关闭定时暂停定时器
        that.operateCompare();//弹出人脸识别
      }, 20*60*1000);
    },
    //关闭人脸识别定时器
    closeCheckFaceTime(){
      console.log("关闭人脸识别定时器")
      clearTimeout(this.compareFaceTimer)
    },
    //提交人脸验证
    submitCompareFace(){
      let that=this
      studyCompareFace(this.comparFaceParam).then(res=>{
        if(res.success){
          that.$toast({
            type:'success',
            message:"认证通过",
            onClose:()=>{
              that.showCheckFace=false
              that.file1=[]
              that.comparFaceParam.upPhoto=""
              //继续播放
              that.operateVideo();//重新继续播放
              that.openPauseTimer();//重新开启暂停定时器
              if(this.ifCheckFace){
              this.startCheckFaceTime();//重新启动人脸识别定时器
              }
              
            }

          })
        }else{
          this.$dialog.alert({
                    message: res.message,
                    theme: 'round-button',
                    confirmButtonText:'确定'
         }).then(()=>{
          console.log(res.message)
          if(res.code ==270){
            that.$router.push("/upload")
          }else if(res.code ==260){
            that.$router.push("/bindCard")
          }
            
         })
        }
      })
    },
    //校验图片的格式
    beforeRead(file) {
      let This = this
      // Array.isArray 是用来校验你是单张图片还是数组的形象做校验
      // 这是多张图片上传
      if (Array.isArray(file)) {
        file.forEach(item => {
          if (!item.type.startsWith('image')) {
            This.$toast("请上传图片！")
            return false
          } else if (item.size > 10485760) {
            This.$toast("图片超过10M！")
            return false
          }
        })
      } else {
      // 这是单张图片校验
        if (!file.type.startsWith('image')) {
          This.$toast("请上传图片！")
          return false
        }
        if (file.size > 10485760) {
          This.$toast("图片超过10M！")
          return false
        }
      }
      // 上传之前校验
      return new Promise((resolve, reject) => {
        // console.log('压缩前', file) // 压缩到400KB,大于400KB的图片都会进行压缩，小于则不会
        // 500是控制压缩大小的 根据你自己的需要调整 数值越小压缩越小

        imageConversion.compressAccurately(file,{
            size:300,
            scale: 0.6,
        } ).then(res => {
          res = new File([res], file.name, { type: res.type, lastModified: Date.now() })
          // console.log('压缩后', res)
          resolve(res)
        }).catch(err=>{
          reject(err)
        })
      })
    },
    //上传人脸照片
    afterRead(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.comparFaceParam.upPhoto = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.comparFaceParam.upPhoto)
        }
      })
    },
    //已学时长转换为式分秒
    getTime(time) {
      let h = parseInt(time / 60 / 60 % 24)
      h = h < 10 ? '0' + h : h
      let m = parseInt(time / 60 % 60)
      m = m < 10 ? '0' + m : m
      let s = parseInt(time % 60)
      s = s < 10 ? '0' + s : s
      return h + ":" + m + ":" + s
    },

    getDetail() {
      let that = this
      getCourseDetail(this.param.projectId).then(res => {
        console.log(res.data.result)
        that.sectionlist = res.data.result.sectionlist;
        that.courseList = res.data.result.courseDetailList;
        // that.study(0)

      })
      getCourseProject(this.param.projectId).then(res => {
        console.log(res.data.result)
        if (res.success) {
          this.title = res.data.result.name
          if(res.data.result.checkFace ==1){
              this.ifCheckFace=true
          }
        }
      })
    },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/home")
    },
    //点击开始学习
    study(index){
      //this.param.courseId =this.courseList[index].sysCourse.id

      //判断是否需要人脸识别
      if(this.ifCheckFace){
        this.comparFaceParam.id =this.courseList[index].sysCourse.id
        //判断是否在手机上观看

        var userAgent = window.navigator.userAgent;
        // if (userAgent.indexOf('micromessenger') !== -1) {
            // 确认是微信浏览器
            if (!/Mobile|iPad|iPhone|iPod/.test(userAgent)) {
                // 确认是PC端
                alert('未检测到摄像头，请使用手机进行观看！');
                // alert('未检测到可，请使用手机进行观看！');
                return false
            } else {
                // 移动端或iPad端
                // console.log('用户使用的是移动端或iPad端的微信浏览器');
                // this.$toast({ message: "使用的是移动端或iPad端的微信浏览器" });
                this.operateCompare()
            }
        // } else {
        //     // 不是微信浏览器
        //     console.log('用户使用的不是微信浏览器');
        // }


        
      }
      if(this.courseNow==index){
        console.log("重复选择")
        this.$toast({ message: "已选择该课程，点击开始学习" });
        return false;
      }
      this.ifready=false
      this.courseNow=index
      this.param.courseId=this.courseList[index].sysCourse.id
      this.src= this.hostdomain+this.courseList[index].sysCourse.vedioUrl
      console.log(this.src)
      console.log(this.param)
      // this.$refs.myVideo.currentTime = this.courseList[index].studyTime
      this.startTime=this.courseList[index].studyTime
      // this.operateVideo(this.courseList[index].studyTime)
     
     
    },
    // 开启定时器
    openTimer() {
      let that = this
      this.timer = setInterval(() => {
        this.$emit("videoStudyTime", this.studyTime);
        console.log(this.studyTime)
        that.subStudytime()
      }, 5000);
    },
    // 关闭定时器
    closeTimer() {
      this.subStudytime()
      clearInterval(this.timer);
      this.$emit("videoStudyTime", this.studyTime);
    },
    // 开启暂停定时器(学习五分钟自动暂停)
    openPauseTimer() {
      let that = this
      console.log("开启暂停定时器")
      this.pauseTimer = setTimeout(() => {
        that.subStudytime()
        that.hintOperate();
      }, 20*60*1000);
    },
    // 关闭暂停定时器（继续学习）
    closePauseTimer() {
      //this.subStudytime()
      console.log("关闭暂停定时器")
      // this.hintOperate();
      // clearInterval(this.pauseTimer);
      clearTimeout(this.pauseTimer)
    },
    // 提示操作
    hintOperate() {
      let that=this
      console.log("调用弹出窗")
      this.operateVideo();//暂停播放
      this.closePauseTimer();//关停暂停定时器
      if(this.ifCheckFace){
        this.closeCheckFaceTime();//关停人脸识别定时器
      }
      this.$dialog.alert({
        message: '请点击确认继续学习', 
      }).then(()=>{
        // that.$refs.myVideo.currentTime = that.videoData.currentTime;
        that.operateVideo();//重新继续播放
        that.openPauseTimer();//重新开启暂停定时器
        if(this.ifCheckFace){
        this.startCheckFaceTime();//重新启动人脸识别定时器
      }
      })
    },
    //启动人脸识别
    operateCompare(){
      console.log("弹出人脸识别窗口")
      this.operateVideo();//暂停播放
      this.closePauseTimer()//关停暂停定时器
      this.file1=[]
      this.comparFaceParam.upPhoto=""
      this.showCheckFace=true
    },
    
    onRateChange() {//播放速度不可倍速
        if (this.$refs.myVideo.playbackRate !== 1.0) {
            this.$refs.myVideo.playbackRate = 1.0;
            console.log('当前播放速度'+this.$refs.myVideo.playbackRate)
        }
    },
    // 获取当前播放位置
    timeupdate(e) {
      if(e.target.currentTime<=0){
        console.log("还未开始")
      }else if(e.target.currentTime- this.courseList[this.courseNow].studyTime<1){
        this.param.duration = e.target.currentTime
        this.courseList[this.courseNow].studyTime= e.target.currentTime
        this.studyTime.currentTime = e.target.currentTime;
        this.studyTime.duration = e.target.duration ? e.target.duration : 0;
      }else{
        alert("警告，禁止拖动学习进度，已记录！")
        this.$refs.myVideo.currentTime=this.courseList[this.courseNow].studyTime
      }

      
    },
    destroyed(){
      this.subStudytime();
      this.closePauseTimer()
      this.closeTimer();
      if(this.ifCheckFace){
        this.closeCheckFaceTime();
      }
    },

    // 操作视频播放、暂停
    operateVideo() { 
      if (!this.src) {
        this.$toast({ message: "暂无视频资源，请查看其他视频！" });
        return false;
      }
      if(!this.ifready){
        this.$toast({ message: "视频未完成加载！" });
        return false;
      }
      // this.startStudy(this.courseList[this.courseNow].sysCourse)
      // this.param.courseId = this.courseList[this.courseNow].sysCourse.id
      if (this.$refs.myVideo.paused) {
        this.videoState = true;
        this.$refs.myVideo.play(); 
        this.openPauseTimer()
        if(this.ifCheckFace){
          this.startCheckFaceTime();
        }
       
      } else {
        this.$refs.myVideo.pause();
        this.closePauseTimer()
        if(this.ifCheckFace){
          this.closeCheckFaceTime();
        }
        this.videoState = false;
      }
    },
    //提交学习进度
    subStudytime() {
      saveStudyTime(this.param).then(res => {
        console.log(res.data)
      })
    }
  },
  watch: {
    // 监听操作
    videoData(val) {
      const { currentTime, duration } = val;
      if (currentTime && duration && currentTime < duration) {
        this.hintOperate();
      }
    },
    // courseNow:()=>{
    //   this.param.courseId= this.courseList[this.courseNow].sysCourse.id
    //   console.log(this.courseList[this.courseNow].sysCourse.id)
    // }
  }


};
</script>

<style lang="less">
.courseDetail li{
  padding: 3px 18px;
  display: flex;
  justify-content: space-between;
  list-style: none;
  line-height: 18px;
}
#common-video{
  width: 100%;
  overflow: hidden;
}
.van-overlay{
  z-index: 1000!important;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 1000000000000;
  }

  .compareFace {
    border-radius:10px;
    width: 80%;
  height: 250PX;
    background-color: #fff;
  }

.active{
  color: red;
}
#common-video {
  position: relative;
  background: #ffffff;

  .video-box {
    box-sizing: border-box;
    border: 0;
    display: block;
    width: 100%;
    //height: auto;
    min-height: 230px;

    outline: none !important;
  }

  .isShow {

    //进度条
    video::-webkit-media-controls-timeline {
      display: none;
    }
  }

  video::-webkit-media-controls-play-button {
    visibility: hidden;
  }

  .operate-btn {
    display: block;
    width: 60px;
    height: 60px;
    position: absolute;
    top: calc(50% - 30px);
    left: calc(50% - 30px);
  }

  .operate-btn:hover {
    opacity: 0.8;
  }

  .fade-out {
    opacity: 0;
  }
}

.bottombox {
  width: 100%;
  height: 46px;
}
</style>

